import React from "react";

// MATERIAL-UI
import { Grid, Typography } from "@mui/material";

// ASSETS
import { HeaderStyles } from "./index.styles";
import { HeaderProps } from "./types";
import ProfilePicture from "../profile-picture";

const Header = (props: HeaderProps) => {
  const classes = HeaderStyles();
  return (
    <Grid container className={classes.container}>
      <Grid item xs={6} container>
        <Grid item xs={12}>
          <Typography className={classes.heading}>{props.heading}</Typography>
        </Grid>
      </Grid>
      <Grid item xs={6} container justifyContent="flex-end">
        {props.picture ? <ProfilePicture picture={props.picture} /> : <div>{""}</div>}
      </Grid>
    </Grid>
  );
};

export default Header;
